<template>
  <div class="course-details">
    <h4 style="font-weight:bold;">
      {{ trans('core.course') }}: {{ course.title }}
      <span
        class="fa fa-trash"
        style="color:#b71c1c; cursor:pointer;"
        :title="trans('core.delete_object', { 'object': trans('core.course') })"
        @click="openModal"
      />
    </h4>
    <p>{{ trans('series.filter_classes_explanation') }}</p>

    <!--delete course from goal modal-->
    <modal
      :id="'delete_modal_' + courseId"
      :open="open"
      :title="trans('core.delete_object', { 'object': trans('core.course') })"
      @close="closeModal"
    >
      <div class="row">
        <div class="col-md-12">
          {{ trans('series.delete_course_question', { course: course.title }) }}
        </div>
        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-danger pull-right"
            @click="deleteCourse"
          >
            {{ trans('core.delete') }}
          </button>
        </div>
      </div>
    </modal>

    <form class="form-horizontal row">
      <div class="col-xs-12 col-lg-6">
        <div class="form-group">
          <label
            class="control-label col-sm-2"
            :for="'select_groups_' + courseId"
          >{{ trans_choice('core.groups',2) }}</label>
          <div class="col-sm-10">
            <query-magic-suggest
              :id="'select_groups_' + courseId"
              v-model="groupIds"
              style="z-index: 250"
              suggest_type="group"
              :value="groupIds"
              :include="{ 'group_id': course.group_ids }"
              :exclude="groupIds != null && groupIds !== [] ? { 'group_id': groupIds } : {}"
              :placeholder="trans('core.type_or_click') + '...'"
              @input="selectValue({ attribute: 'groupIds', value: groupIds })"
            />
          </div>
        </div>

        <div class="form-group">
          <label
            class="control-label col-sm-2"
            :for="'select_event_name_' + courseId"
          >{{ trans('core.name') }}</label>
          <div class="col-sm-10">
            <query-magic-suggest
              :id="'select_event_name_' + courseId"
              v-model="eventNames"
              style="z-index:200"
              suggest_type="event-name"
              :value="eventNames"
              :include="{ 'course_id': courseId }"
              :placeholder="trans('core.type_or_click') + '...'"
              @input="selectValue({ attribute: 'eventNames', value: eventNames })"
            />
          </div>
        </div>

        <div class="form-group">
          <label
            class="control-label col-sm-2"
            :for="'select_event_categorie_' + courseId"
          >{{ trans('core.type') }}</label>
          <div class="col-sm-10">
            <query-magic-suggest
              :id="'select_event_categorie_' + courseId"
              v-model="eventTypes"
              style="z-index:200"
              suggest_type="event-categorie"
              :value="eventTypes"
              :include="{ 'course_id': courseId }"
              :placeholder="trans('core.type_or_click') + '...'"
              @input="selectValue({ attribute: 'eventTypes', value: eventTypes })"
            />
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-lg-6">
        <date-picker-component
          :id="'select_startdate_' + courseId"
          v-model="startdate"
          :value="startdate"
          :label="trans( 'core.startdate')"
          @input="selectValue({ attribute: 'startdate', value: startdate })"
        />
        <date-picker-component
          :id="'select_enddate_' + courseId"
          v-model="enddate"
          :value="enddate"
          :label="trans( 'core.enddate')"
          @input="selectValue({ attribute: 'enddate', value: enddate })"
        />
      </div>
    </form>
  </div>
</template>

<script>
import SelectorComponent from '../FormComponents/SelectorComponent.vue'
import Suggest from './../Suggest.vue'
import DatePickerComponent from './../FormComponents/DatePickerComponent.vue'
import Modal from './../../../students/student-calendar/components/Modal.vue'
import QueryMagicSuggest from '../QueryMagicSuggest'

export default {

  name: 'SelectCourseDetails',
  components: { QueryMagicSuggest, DatePickerComponent, SelectorComponent, Suggest, Modal },

  props: {
    courseId: {
      required: true,
      type: String,
    },
  },

  data () {
    return {
      open: false,
      groupIds: [],
      eventNames: [],
      eventTypes: [],
      startdate: null,
      enddate: null,
      changedCourseId: false,
    }
  },

  computed: {
    course () {
      return this.$store.state.eventSeries.courses[this.courseId]
    },
    events () {
      return this.$store.state.eventSeries.events[this.courseId]
    },
    course_event_ids () {
      return this.$store.state.eventSeries.course_event_ids[this.courseId]
    },
  },

  watch: {
    courseId: function () {
      this.groupIds = this.course.chosen_groupIds
      this.eventNames = this.course.chosen_eventNames
      this.eventTypes = typeof this.course.chosen_eventTypes === 'string' ? [this.course.chosen_eventTypes] : this.course.chosen_eventTypes
      this.startdate = this.course.chosen_startdate
      this.enddate = this.course.chosen_enddate
    },
  },

  mounted () {
    this.groupIds = this.course.chosen_groupIds
    this.eventNames = this.course.chosen_eventNames
    this.eventTypes = typeof this.course.chosen_eventTypes === 'string' ? [this.course.chosen_eventTypes] : this.course.chosen_eventTypes
    this.startdate = this.course.chosen_startdate
    this.enddate = this.course.chosen_enddate
    this.recalculateEvents()
  },

  methods: {
    openModal () {
      this.open = true
    },
    closeModal () {
      this.open = false
    },

    deleteCourse () {
      this.$emit('deleteCourse', this.courseId)
      this.closeModal()
    },

    selectValue ({ attribute, value }) {
      let name = 'chosen_' + attribute
      this.$store.dispatch('update_course', { courseId: this.courseId, name: name, value: value }).then(() => {
        this.recalculateEvents()
      })
    },

    recalculateEvents () {
      let filteredEvents = Object.values(this.events)

      if (this.startdate != null) {
        filteredEvents = filteredEvents.filter(event => {
          return moment(event.starttime) >= moment(this.startdate)
        })
      }
      if (this.enddate != null) {
        filteredEvents = filteredEvents.filter(event => {
          return moment(event.endtime) <= moment(this.enddate)
        })
      }
      if (this.eventNames != null && (Array.isArray(this.eventNames) && this.eventNames.length !== 0)) {
        /* we want to show all lessons corresponding to the names, ignoring upper/lower case */
        let eventNamesLC = this.eventNames.map(name => name.toLowerCase())
        filteredEvents = filteredEvents.filter(event => {
          return eventNamesLC.includes(event.name.toLowerCase())
        })
      }
      if (this.eventTypes !== null && (Array.isArray(this.eventTypes) && this.eventTypes.length !== 0)) {
        filteredEvents = filteredEvents.filter(event => {
          return this.eventTypes.includes(event.type)
        })
      }
      if (this.groupIds != null && (Array.isArray(this.groupIds) && this.groupIds.length !== 0)) {
        filteredEvents = filteredEvents.filter(event => {
          return event.group_ids.some(value => this.groupIds.includes(value))
        })
      }
      let filteredEventIds = filteredEvents.map((event) => { return event.id })

      return this.$store.dispatch('update_course_event_ids', { courseId: this.courseId, eventIds: filteredEventIds })
    },
  },
}
</script>

<style>
    .course-details {
        margin: 20px 15px;
        padding: 10px;
        border: 1px solid lightgray;
        border-left: 3px solid #25167a;
    }

    .el-date-editor {
        width: 100% !important;
    }

</style>
